module.exports = __webpack_public_path__ + "static/media/carousel-placeholder-2.ade88dc5.jpg";